export default __webpack_public_path__ + "static/media/4.42b8fb04.png";